import { render, staticRenderFns } from "./DocumentRegisteredNavigator.vue?vue&type=template&id=6a34692b&scoped=true&"
import script from "./DocumentRegisteredNavigator.vue?vue&type=script&lang=ts&"
export * from "./DocumentRegisteredNavigator.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentRegisteredNavigator.vue?vue&type=style&index=0&id=6a34692b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a34692b",
  null
  
)

export default component.exports